export default __webpack_public_path__ + "static/media/discount_3d.536793f9.png";